import { ActionType } from 'typesafe-actions';
import * as actions from './actions';
import { AxiosError } from 'axios';

export type TasksAction = ActionType<typeof actions>;

export interface TasksState {
  tasks: {
    data: Task[] | null;
    loading: boolean;
    error: AxiosError | null;
  };
  task: {
    data: Task | null;
    loading: boolean;
    error: AxiosError | null;
  };
}

export interface TaskParams {
  enterpriseId: string;
  projectId?: string;
  taskId?: string;
  task?: any;
}

export interface TaskCommentParams {
  enterpriseId: string;
  projectId?: string;
  taskId?: string;
  data?: any;
}

export enum TaskStatus {
  WORK_REQUEST = '0',
  IN_PROGRESS = '1',
  READY_FOR_REVIEW = '2',
  CLOSED = '3',
  HOLD = '4',
}

export const taskStatusKorean = {
  '0': '작업요청',
  '1': '진행중',
  '2': '확인요청',
  '3': '완료',
  '4': '보류',
} as const;

export interface Task {
  id: number;
  name: string;
  status: string;
  description: string;
  file: any;
  dueDate: string;
  requester: any;
  assignee: any;
  project: any;
  taskComments: TaskComment[];
  createdAt: string;
  updatedAt: string;
}

export interface TaskComment {
  id: number;
  description: string;
  file: any;
  user: any;
  createdAt: string;
}
